import { MyContext } from "../../../../context";
import React, { Component } from 'react';
import { MessageBar, MessageBarButton, MessageBarType } from 'office-ui-fabric-react';

export default class AlertNoAddOnCompliance extends Component {

    static contextType = MyContext

    render() {

        return (
            <div style={{ marginBottom: 5 }}>
                <MessageBar
                    messageBarType={MessageBarType.blocked}
                    //actions={<div>
                    //    <MessageBarButton onClick={this.props.onClick}>
                    //        {this.context.getTranslation('compliance', 'removeUsersWithoutAOCActionLabel')}</MessageBarButton>
                    //</div>}
                >
                    {this.context.getTranslation('compliance', 'removeUsersWithoutAOCNotice')}
                </MessageBar>
            </div>
        )
    }

}